/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import HealthEntryCategoryNames from '../../constants/HealthEntryCategoryNames';
import ShareCardIncludedTypeNames from '../../constants/ShareCardIncludedTypeNames';
import healthEntryTextFormatting from '../../models/HealthEntryTextFormatting';
import { useActiveUser } from '../hooks/useUser';

interface Props {
  healthEntry: any;
  includedValues: any;
  style?: any;
  className?: string;
  languageCode?: string;
}
const HealthEntryNameText: React.FC<Props> = (props) => {
  const [{ preferredLanguageCode }] = useActiveUser();

  const healthEntryTextFormatter = healthEntryTextFormatting(props.healthEntry);
  let titleText: any = '';
  const languageCode = props.languageCode || preferredLanguageCode;
  const showValueInfo = props.includedValues !== ShareCardIncludedTypeNames.all;

  switch (props.healthEntry.category) {
    case HealthEntryCategoryNames.lab:
    case HealthEntryCategoryNames.measurement:
    case HealthEntryCategoryNames.geneticResult:
      if (props.includedValues === ShareCardIncludedTypeNames.all) {
        titleText = healthEntryTextFormatter.nameWithAnatomy(languageCode);
      } else {
        titleText = healthEntryTextFormatter.nameWithLatestValue(languageCode, showValueInfo);
      }
      break;
    default:
      titleText = healthEntryTextFormatter.nameWithAnatomy(languageCode);
      break;
  }

  return (
    <span className={props.className} style={props.style}>
      {titleText}
    </span>
  );
};

export default HealthEntryNameText;
